<script setup>
	import { defineProps } from 'vue';

	const props = defineProps(['startDate', 'endDate']);

	const isDateBeforeStartDate = () => {
		return new Date() < new Date(props.startDate);
	};
	const isDateAfterEndDate = () => {
		return new Date() > new Date(props.endDate);
	};
	const isDateBetweenStartEndDates = () => {
		return !isDateAfterEndDate(props.endDate) && !isDateBeforeStartDate(props.startDate);
	};
</script>

<!-- ================================================================================== -->

<template>
	<span>
		<span v-if="isDateBeforeStartDate()">📦 Pré-live</span>
		<span v-if="isDateBetweenStartEndDates()">💖 Live</span>
		<span v-if="isDateAfterEndDate()">💀 Post-live</span>
	</span>
</template>

<!-- ================================================================================== -->

<style lang="scss" scoped>

</style>
